// if (!customElements.get('media-gallery')) {
//   customElements.define(
//     'media-gallery',
//     class MediaGallery extends HTMLElement {
//       constructor() {
//         super();
//         this.elements = {
//           liveRegion: this.querySelector('[id^="GalleryStatus"]'),
//           viewer: this.querySelector('[id^="GalleryViewer"]'),
//           thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
//         };
//         this.mql = window.matchMedia('(min-width: 750px)');
//         if (!this.elements.thumbnails) return;

//         this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
//         this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
//           mediaToSwitch
//             .querySelector('button')
//             .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
//         });
//         if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
//       }

//       onSlideChanged(event) {
//         const thumbnail = this.elements.thumbnails.querySelector(
//           `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
//         );
//         this.setActiveThumbnail(thumbnail);
//       }

//       setActiveMedia(mediaId, prepend) {
//         const activeMedia =
//           this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
//           this.elements.viewer.querySelector('[data-media-id]');
//         if (!activeMedia) {
//           return;
//         }
//         this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
//           element.classList.remove('is-active');
//         });
//         activeMedia?.classList?.add('is-active');

//         if (prepend) {
//           activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

//           if (this.elements.thumbnails) {
//             const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
//             activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
//           }

//           if (this.elements.viewer.slider) this.elements.viewer.resetPages();
//         }

//         this.preventStickyHeader();
//         window.setTimeout(() => {
//           if (!this.mql.matches || this.elements.thumbnails) {
//             activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
//           }
//           const activeMediaRect = activeMedia.getBoundingClientRect();
//           // Don't scroll if the image is already in view
//           if (activeMediaRect.top > -0.5) return;
//           const top = activeMediaRect.top + window.scrollY;
//           window.scrollTo({ top: top, behavior: 'smooth' });
//         });
//         this.playActiveMedia(activeMedia);

//         if (!this.elements.thumbnails) return;
//         const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
//         this.setActiveThumbnail(activeThumbnail);
//         this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
//       }

//       setActiveThumbnail(thumbnail) {
//         if (!this.elements.thumbnails || !thumbnail) return;

//         this.elements.thumbnails
//           .querySelectorAll('button')
//           .forEach((element) => element.removeAttribute('aria-current'));
//         thumbnail.querySelector('button').setAttribute('aria-current', true);
//         if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

//         this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
//       }

//       announceLiveRegion(activeItem, position) {
//         const image = activeItem.querySelector('.product__modal-opener--image img');
//         if (!image) return;
//         image.onload = () => {
//           this.elements.liveRegion.setAttribute('aria-hidden', false);
//           this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
//           setTimeout(() => {
//             this.elements.liveRegion.setAttribute('aria-hidden', true);
//           }, 2000);
//         };
//         image.src = image.src;
//       }

//       playActiveMedia(activeItem) {
//         window.pauseAllMedia();
//         const deferredMedia = activeItem.querySelector('.deferred-media');
//         if (deferredMedia) deferredMedia.loadContent(false);
//       }

//       preventStickyHeader() {
//         this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
//         if (!this.stickyHeader) return;
//         this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
//       }

//       removeListSemantic() {
//         if (!this.elements.viewer.slider) return;
//         this.elements.viewer.slider.setAttribute('role', 'presentation');
//         this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
//       }
//     }
//   );
// }


if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        // ── Vertical layout active at >= 1024px ──
        this.verticalMql = window.matchMedia('(min-width: 1025px)');
        this.thumbnailList = this.elements.thumbnails.querySelector('[id^="Slider-Thumbnails"]');

        this._updateIsVertical();

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        if (this.isVerticalThumbnails) {
          this.initVerticalThumbnailButtons();
        }

        // ── Re-evaluate on resize ──
        this.verticalMql.addEventListener('change', () => {
          this._updateIsVertical();
          if (this.isVerticalThumbnails) {
            this.initVerticalThumbnailButtons();
          }
        });
      }

      // ── Determine vertical mode and force-show thumbnail strip on iPad Pro ──
      _updateIsVertical() {
        const hasLeftClass = this.elements.thumbnails.classList.contains('thumbnail-slider--left_thumbnails');
        this.isVerticalThumbnails = hasLeftClass && this.verticalMql.matches;

        // At 1024px the Dawn theme adds small-hide which hides thumbnails.
        // Force-show them when vertical mode is active.
        if (this.isVerticalThumbnails) {
          this.elements.thumbnails.style.display = 'flex';
        } else {
          this.elements.thumbnails.style.display = '';
        }
      }

      // ── Vertical prev/next button handler ──
      initVerticalThumbnailButtons() {
        const sliderList = this.thumbnailList;
        const prevBtn = this.elements.thumbnails.querySelector('.slider-button--prev');
        const nextBtn = this.elements.thumbnails.querySelector('.slider-button--next');

        if (!sliderList || !prevBtn || !nextBtn) return;

        // Guard: don't attach duplicate listeners
        if (this._verticalButtonsInited) return;
        this._verticalButtonsInited = true;

        // ── Force-remove disabled attribute and watch for it being re-added ──
        prevBtn.removeAttribute('disabled');
        nextBtn.removeAttribute('disabled');

        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'disabled') {
              mutation.target.removeAttribute('disabled');
            }
          });
        });
        observer.observe(prevBtn, { attributes: true });
        observer.observe(nextBtn, { attributes: true });

        const getStep = () => {
          const firstItem = sliderList.querySelector('.thumbnail-list__item');
          if (!firstItem) return 110;
          const gap = parseInt(window.getComputedStyle(sliderList).gap || '10', 10);
          return firstItem.offsetHeight + gap;
        };

        // ── Use capture:true to fire before slider-component's own handlers ──
        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          sliderList.scrollBy({ top: -(getStep() * 3), behavior: 'smooth' });
          setTimeout(() => this._updateVerticalBtnState(prevBtn, nextBtn, sliderList), 400);
        }, true);

        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          sliderList.scrollBy({ top: getStep() * 3, behavior: 'smooth' });
          setTimeout(() => this._updateVerticalBtnState(prevBtn, nextBtn, sliderList), 400);
        }, true);

        sliderList.addEventListener('scroll', () => {
          this._updateVerticalBtnState(prevBtn, nextBtn, sliderList);
        });

        // ── Wait for full layout paint before checking scroll state ──
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setTimeout(() => this._updateVerticalBtnState(prevBtn, nextBtn, sliderList), 200);
          });
        });
      }

      // ── Show/hide arrows based on actual scrollable content ──
      _updateVerticalBtnState(prevBtn, nextBtn, sliderList) {
        const scrollTop    = Math.round(sliderList.scrollTop);
        const offsetHeight = sliderList.offsetHeight;
        const scrollHeight = sliderList.scrollHeight;

        // Only hide prev at very top, only hide next at very bottom
        // If there is nothing to scroll (scrollHeight <= offsetHeight), hide both
        const hasOverflow = scrollHeight > offsetHeight + 4;
        const atTop       = scrollTop <= 2;
        const atBottom    = scrollTop + offsetHeight >= scrollHeight - 4;

        prevBtn.style.opacity       = (!hasOverflow || atTop)    ? '0' : '1';
        prevBtn.style.pointerEvents = (!hasOverflow || atTop)    ? 'none' : 'auto';
        nextBtn.style.opacity       = (!hasOverflow || atBottom) ? '0' : '1';
        nextBtn.style.pointerEvents = (!hasOverflow || atBottom) ? 'none' : 'auto';
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail &&
              activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', 'true');
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        // ── Vertical scroll for left layout, horizontal for default ──
        if (this.isVerticalThumbnails && this.thumbnailList) {
          this.thumbnailList.scrollTo({ top: thumbnail.offsetTop, behavior: 'smooth' });
        } else {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
